import { connect } from 'react-redux';

import RatingInput from './presentation';

export default connect(({
  content: { userData },
}) => ({
  userData,
}))(RatingInput);
